var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "170.079px",
    height: "170.079px",
    viewBox: "0 0 170.079 170.079",
    enableBackground: "new 0 0 170.079 170.079",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.948,101.109c-0.07-9.091,1.569-17.533,5.816-25.347 c5.409-9.952,13.7-16.475,24.472-19.663c11.449-3.388,22.938-3.142,34.159,1.075c11.635,4.372,19.583,12.57,23.991,24.173 c3.088,8.131,3.751,16.576,3.047,25.175c-0.6,7.322-2.59,14.226-6.357,20.562c-5.523,9.288-13.654,15.211-23.938,18.236 c-6.723,1.979-13.604,2.41-20.577,1.851c-7.458-0.601-14.464-2.606-20.837-6.574c-8.561-5.33-14.118-13.001-17.254-22.502 C62.624,112.496,61.892,106.727,61.948,101.109z M129.569,100.849c-0.396-3.355-0.654-6.734-1.219-10.062 c-0.801-4.725-2.562-9.083-5.966-12.578c-5.899-6.058-13.173-7.052-20.936-5.049c-6.401,1.651-10.474,6.212-12.659,12.262 c-3.278,9.08-3.265,18.391-1.021,27.706c1.089,4.516,3.202,8.519,6.741,11.648c4.001,3.538,8.785,4.621,13.984,4.491 c8.125-0.205,14.031-3.864,17.558-11.21C128.657,112.632,129.249,106.801,129.569,100.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.661,145c-8.076,0-16.086,0-24.263,0c0-0.464,0-0.879,0-1.294 c0-28.63,0.005-57.26-0.02-85.891c0-1.031,0.218-1.407,1.336-1.399c7.284,0.05,14.568,0.025,21.852,0.028 c0.342,0,0.684,0.037,1.095,0.062C48.661,86.002,48.661,115.434,48.661,145z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.475,22.682c8.067,0,16.072,0,24.168,0c0,6.654,0,13.292,0,20.024 c-8.03,0-16.061,0-24.168,0C24.475,36.032,24.475,29.395,24.475,22.682z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIo);
export default __webpack_public_path__ + "static/media/logo-io.37942138ce2013727f667f6dbe37b8c2.svg";
export { ForwardRef as ReactComponent };